//loader
import definition from 'communication_definition';
import definition_task from 'task_definition';
import definition_market from 'market_definition';

global.app.sdk.communication = global.app.create_sdk(definition, true);
if (global.app.name === 'communication_ui') {
  global.app.sdk.tasks = global.app.create_sdk(definition_task, true);
  global.app.sdk.market = global.app.create_sdk(definition_market, true);
}

global.app['comunication_ui'] = {};
